import { InferGetStaticPropsType } from 'next';

import { Box } from '@chakra-ui/react';

import { PageCategory } from '~/features/analytics/constants';
import { CatalogSubcategoriesSection } from '~/features/experiments/ab_plp_redesign_2025/components/catalog-subcategories-section';
import { PageHead } from '~/features/page/components/page-head';
import { PageLayout } from '~/features/page/components/page-layout';
import { BreadcrumbStructuredData } from '~/features/seo/components/breadcrumb-structured-data';
import { CATALOG_BREADCRUMB, HOME_BREADCRUMB } from '~/features/seo/utils/create-breadcrumb-structured-data';
import { useSessionReplay } from '~/features/session-replay';
import { useI18n } from '~/hooks/use-i18n';
import type { getStaticProps } from '~/pages/catalog';

import { CatalogSearchCatalog } from './catalog-search-catalog';
import { CatalogSearchHeroSection } from './catalog-search-hero-section';

export type CatalogSearchPageProps = InferGetStaticPropsType<typeof getStaticProps>;

export function CatalogSearchPage({
  page,
  catalogSearchResults,
  schoolUriFilters,
  skillUriFilters,
  staticCatalogSubcategoriesSectionProps,
}: CatalogSearchPageProps) {
  const { isTranslated } = useI18n();

  useSessionReplay();

  return (
    <>
      <PageHead page={page} pageCategory={PageCategory.Catalog} />
      <BreadcrumbStructuredData crumbs={[HOME_BREADCRUMB, CATALOG_BREADCRUMB]} />
      <PageLayout withoutVerticalPadding>
        <Box bgColor='white' paddingBottom={{ md: '40px' }}>
          <CatalogSearchHeroSection />
          <Box paddingBottom={{ base: '56px', md: 0 }} paddingTop={{ base: '16px', md: '40px' }}>
            <CatalogSearchCatalog
              initialCatalogSearchResults={catalogSearchResults}
              schoolUriFilters={schoolUriFilters}
              skillUriFilters={skillUriFilters}
            />
          </Box>
          {!isTranslated && (
            <Box paddingTop={{ md: '40px' }}>
              <CatalogSubcategoriesSection {...staticCatalogSubcategoriesSectionProps} />
            </Box>
          )}
        </Box>
      </PageLayout>
    </>
  );
}
